export const breakpointSizes = {
    lg: 960,
    md: 800,
    sm: 640,
    xl: 1280,
    xs: 320,
};
const breakpoints = {
    lg: `${breakpointSizes['lg']}px`,
    md: `${breakpointSizes['md']}px`,
    sm: `${breakpointSizes['sm']}px`,
    xl: `${breakpointSizes['xl']}px`,
    xs: `${breakpointSizes['xs']}px`,
};
export default breakpoints;
